export default [
	'Developer',
	'Institutional',
	'Real Estate Professional'
];